export enum DataTypeProps {
  displayedDataType = "displayedDataType",
  dataTypeToFetch = "dataTypeToFetch"
}
